var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFooterInfo = function SvgIcFooterInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#585A64",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m.875-9.625a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-1.75 1.75a.656.656 0 1 0 0 1.313h.219v1.75h-.875a.656.656 0 1 0 0 1.312H9.53a.656.656 0 1 0 0-1.312h-.875V7.124z",
    clipRule: "evenodd"
  })));
};
export default SvgIcFooterInfo;